import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

export interface SignaturePayload {
  base64String: string;
  contentType: string;
}

export interface UpdateSignatureRequest {
  signature: SignaturePayload;
}

export interface UpdatePinRequest {
  pin: string;
}

/** POST /api/v1/users/delegations — grantee may act on behalf of the authenticated user. */
export interface CreateUserDelegationRequest {
  granteeUserId: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private readonly baseUrl = `${environment.adminApiBaseUrl}api/v1/users/profile`;
  private readonly delegationsUrl = `${environment.adminApiBaseUrl}api/v1/users/delegations`;

  constructor(private readonly dataService: DataService) {}

  updateSignature(userId: string, request: UpdateSignatureRequest): Observable<void> {
    const url = `${this.baseUrl}/${userId}`;
    return this.dataService.patch(url, request);
  }

  updatePin(userId: string, request: UpdatePinRequest): Observable<void> {
    const url = `${this.baseUrl}/${userId}`;
    return this.dataService.patch(url, request);
  }

  createDelegation(request: CreateUserDelegationRequest): Observable<void> {
    return this.dataService.post(this.delegationsUrl, request);
  }

  /** DELETE /api/v1/users/delegations/{delegationId} */
  deleteDelegation(delegationId: string): Observable<void> {
    const url = `${this.delegationsUrl}/${encodeURIComponent(delegationId)}`;
    return this.dataService.delete(url);
  }
}

